import * as R from "ramda";
import * as React from "react";
import { FaCircle } from "react-icons/fa";
import { Link } from "react-router-dom";
import styled from "styled-components";

import { courseUnitViews } from "../../../../utils/courseViews";
import { PreferredLocale } from "../../../../utils/locales";
import { findComponent } from "../../../course-author/helpers/patches/util";
import { CourseUnitView, DefaultNames, ICourseUnit, IFullCourse, Slide } from "../../../course-author/types";
import { ClickableComponentLink, ComponentLinkDiv } from "./ComponentLink";

interface IUnitPathLinksProps {
  course: IFullCourse;
  currentLocale: PreferredLocale;
  displayedComponent: Slide | null;
  moveUpUnitPath: (idx: number) => () => void;
  rootUrl: string;
  unitPath: CourseUnitView[];
}
const UnitComponentLinkDiv = styled(ComponentLinkDiv)`
  flex-wrap: wrap;
  width: 100%;
  height: auto;
  min-height: 3rem;
  align-items: center;
  overflow: hidden;
  svg {
    margin: 0rem 0.8rem;
    height: 1.8rem;
    width: 2rem;
  }
`;
const IconDiv = styled.div`
  display: block;
`;
export const UnitPathLinks: React.SFC<IUnitPathLinksProps> = ({
  course,
  currentLocale,
  displayedComponent,
  moveUpUnitPath,
  rootUrl,
  unitPath,
}: IUnitPathLinksProps) => {
  const unitLinkList = unitPath
    .map(view => view(course))
    .filter(R.compose(R.not, R.isNil))
    .map((unit: ICourseUnit, i: number) => {
      return (
        <UnitComponentLinkDiv key={i} data-selected={displayedComponent === unit}>
          <Link
            to={`${rootUrl}?position=${findComponent(course, unitPath.slice(0, i), unit)}`}
            onClick={moveUpUnitPath(i)}
          >
            <ClickableComponentLink>
              <IconDiv>
                <FaCircle />
              </IconDiv>
              {courseUnitViews.localizedTitle(unit, currentLocale) || DefaultNames.Unit}
            </ClickableComponentLink>
          </Link>
        </UnitComponentLinkDiv>
      );
    });

  if (unitLinkList.length > 0) {
    return <>{unitLinkList}</>;
  }

  return null;
};
